import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const features = [
    {
      icon: '🏆',
      title: 'Trusted by Locals',
      description: 'Most preferred dental clinic in Bhaktapur with excellent reputation'
    },
    {
      icon: '💉',
      title: 'Painless Treatment',
      description: 'Advanced techniques ensuring comfortable, pain-free procedures'
    },
    {
      icon: '💰',
      title: 'Affordable Care',
      description: 'High-quality dental services at competitive, transparent pricing'
    },
    {
      icon: '🔬',
      title: 'Modern Technology',
      description: 'Latest dental equipment and cutting-edge treatment methods'
    },
    {
      icon: '🧼',
      title: 'International Hygiene',
      description: 'Strict sterilization protocols meeting global healthcare standards'
    },
    {
      icon: '📍',
      title: 'Convenient Location',
      description: 'Easily accessible from Suryabinayak, Katunje, and surrounding areas'
    }
  ];

  return (
    <section className="why-choose-us" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2>Why We're the Best Dental Clinic in Bhaktapur</h2>
        </motion.div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-item"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -5, scale: 1.02 }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
